if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll('select option[selected][data-option-value-id], fieldset input:checked[data-option-value-id]')
        ).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          if (target.matches('[data-size-group-control]')) {
            this.handleSizeGroupChange(target, event);
            return;
          }

          this.syncRadioCheckedAttributes(target);
          this.updateSelectedSwatchValue(event);
          this.publishOptionValueSelectionChange(event, target);
        });
      }

      publishOptionValueSelectionChange(event, target) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }

      syncRadioCheckedAttributes(input) {
        if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;

        const root = input.closest('variant-selects') || this;
        root.querySelectorAll('input[type="radio"]').forEach((radio) => {
          if (radio.name !== input.name) return;

          if (radio === input) {
            radio.setAttribute('checked', 'checked');
          } else {
            radio.removeAttribute('checked');
          }
        });
      }

      handleSizeGroupChange(control, event) {
        const picker = control.closest('[data-size-group-picker]');
        const group = control.dataset.sizeGroup;
        if (!picker || !group) return;

        this.setSizeGroupVisibility(picker, group);

        const select = picker.querySelector('select');
        if (select) {
          const selectedOption = select.selectedOptions[0];
          if (selectedOption?.dataset.sizeChoice === group) return;

          const nextOption =
            Array.from(select.options).find((option) => option.dataset.sizeChoice === group && !option.disabled) ||
            Array.from(select.options).find((option) => option.dataset.sizeChoice === group);

          if (nextOption) {
            select.value = nextOption.value;
            this.updateSelectedSwatchValue({ target: select });
            this.publishOptionValueSelectionChange(event, select.selectedOptions[0] || nextOption);
          } else if (selectedOption) {
            this.publishOptionValueSelectionChange(event, selectedOption);
          }
          return;
        }

        const selectedInput = picker.querySelector('input[type="radio"][data-size-choice]:checked');
        if (selectedInput?.dataset.sizeChoice === group) {
          this.syncRadioCheckedAttributes(selectedInput);
          this.updateSelectedSwatchValue({ target: selectedInput });
          this.publishOptionValueSelectionChange(event, selectedInput);
          return;
        }

        const nextInput =
          picker.querySelector(`input[type="radio"][data-size-choice="${group}"]:not(.disabled):not(:disabled)`) ||
          picker.querySelector(`input[type="radio"][data-size-choice="${group}"]`);

        if (nextInput) {
          nextInput.checked = true;
          this.syncRadioCheckedAttributes(nextInput);
          this.updateSelectedSwatchValue({ target: nextInput });
          this.publishOptionValueSelectionChange(event, nextInput);
        }
      }

      setSizeGroupVisibility(picker, activeGroup) {
        picker.dataset.activeSizeGroup = activeGroup;

        picker.querySelectorAll('[data-size-choice]').forEach((choice) => {
          const shouldShow = choice.dataset.sizeChoice === activeGroup;
          choice.hidden = !shouldShow;

          if (choice.tagName === 'INPUT' && choice.id) {
            const label = picker.querySelector(`label[for="${choice.id}"]`);
            if (label) label.hidden = !shouldShow;
          }
        });
      }
    }
  );
}
